// dependencies
import React, { useState } from "react";
import axios from "axios";
import router, { Router } from "next/router";
import _get from "lodash/get";
import _ from "lodash"
// scss
import styles from "../../../styles/pages/userMapping.module.scss";
import Icons from "../../../public/assets/svg/index";
// endpoint
import endpoints from "../../../utility/endpoints";
import Loader from "../../../components/Loader";
// components
import SuccessModal from "../../../pages/successModal";
import Edituser from "../../../components/userEditModal/index";
import BasicForm2 from "../../../components/BasicForm2";
import BasicForm3 from "../../../components/BasicForm3";
import BasicForm from "../../../components/basicForm";
import AddUser from "../../adduser/index.jsx";
import DropDown from "../../listWithoutcheck";

import { useMediaQuery } from "react-responsive";
import Fuse from "fuse.js";
import Pagination from "../../Pagination";
import UploadFile from "../../uploadFile";
import {
  sessionTimeOutCheck,
  checkExpiry,
} from "../../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
//import { Dropdown } from "reactstrap";

function index(props) {
  //console.log("props admin access ", props)
  const editUserSucessFailure = _get(
    props,
    "data.field_component[4].component.content.field_message_type_value_pair",
    []
  );
  const deleteUser = _get(
    props,
    "data.field_component[3].component.content.field_message_type_value_pair",
    []
  );
  const createUser = _get(
    props,
    "data.field_component[2].component.content.field_message_type_value_pair",
    []
  );
  //console.log("Create User  ---", createUser);
  const [loader, setLoaader] = useState(false);
  const drupalData = props.data;
  const globalData = props.globalData;
  const inputRef = React.useRef(null);
  let notRequired=['Area','Sub Area','MCO','Lead Platform']
  // console.log("Drupal data user acess mapping  ---", props);
  const isMobile = useMediaQuery({ query: "(max-width: 720px)" });

  // get routes of all page
  const routes = props.data.site_info.menu_component.menu_list;
  // sucess modal state and message
  const [successModal, setSuccessModal] = React.useState(false);
  const [message, setMessage] = React.useState("User created!");
  const [fail, setFail] = React.useState(false);
  const [usertypeToShow , setUserTypeToShow] = React.useState("All");
  // saving auth data to state
  const [authData, setAuthData] = React.useState(null);

  // edit user data
  const [editUser, setedituser] = useState(false);
  
  // user data from get api
  const [userData, setUserData] = React.useState([]);
  const [filteredUserData, setFilteredUserData] = React.useState([]);
  // the user to be edited
  const [userToBeEdited, setUserToBeEdited] = React.useState({});
  const [offset, setOffset] = useState(0);
  const [paginationNum, setPaginationNum] = useState(1);

  const [dropDownState, setDropdownState] = React.useState(false);
  const [userCount, setCount] = useState(0);
  const [searchUser, setsearchUser] = useState("");
  const [checked,setChecked] = useState(false);
  const [valued,setValued] = useState("")
  const [firstTime, setFirstTime] = useState(true)
  

  // get user user data

  const getUserData = async (search,userFilter, initial) => {
    let sr = "";
    let offsetA = offset;
    //console.log("Offset", offset);
    if (search) {
      //console.log("here");
      sr = search;
      //console.log("search", search);
      // offsetA = 0;
    }
    try {
      const auth = await JSON.parse(localStorage.getItem("auth")).data;
      setAuthData(auth);

      // let offset = 5;
      setLoaader(true);
      const resp = await axios({
        method: "GET",
        url: `${endpoints.baseUrl}/user/allUser`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
        params: {
          offset: initial ? 0 : offsetA,
          search: sr,
          userTypeFilter : userFilter ? userFilter : "All"
        },
      });
      setLoaader(false);
      if (resp.data.code == 403) {
        localStorage.removeItem("auth");
        router.push(routes.Login);
        setLoaader(false)
        props.sessionTimeOutCheck(true)

      } else {
        //console.log(resp.data.data, "response of response");
        setFirstTime(false)
        //console.log("thisBeforesettingfalse")
        setCount(resp.data.data.count);
        setUserData(resp.data.data.rows);
        setFilteredUserData([...resp.data.data.rows]);
      }
    } catch (e) {
      console.log(e, "error that I want")
      router.push(routes.Login);
    }
  };

  // Get User Data From Data
  React.useEffect(async () => {
    //console.log("search user ", searchUser);
    if (!firstTime) {
      await getUserData(searchUser, userTypeFilter);
    }
      
    
    
  }, [offset]);

  React.useEffect(async () => {
    
      await getUserData(searchUser, userTypeFilter);
        
  }, []);

  

  React.useEffect(() => {
    paginationNum >= 1 && setOffset((paginationNum - 1) * 10);
  }, [paginationNum]);
  // initial state for create user
  let initialState = {
    name: "",
    image: "",
    email: "",
    userType: "",
  };

  const [createUserState, setCreateUserState] = React.useState(initialState);
  const [ invalidUserType,setInvalidUserType] = useState(false)
  const [  invalidUsertypeMobileError ,setUsertypeMobileError] = useState(false)
  const [invalidFlag, setInvalidFlag] = React.useState(false);
  const [ userTypeFilter, setUserTypeFilter ] = React.useState("All")

  // drop down values from global component
  const leadPlatformData = props.globalData.lead_platform_main_component[0];
  const areaData = props.globalData.lead_platform_main_component[1];
  const subAreaData = props.globalData.lead_platform_main_component[2];

  const clusterData = props.globalData.cluster_main_component[0];
  const mcoData = props.globalData.cluster_main_component[1];
  const landscapData = 
    {
      "field_form_field_title": "Landscape",
      "field_label": "Landscape",
      "field_input_type": "Dropdown",
      "field_related_dropdown": null,
      "field_options": [
        "Cordillera",
        "Fusion",
        "Global",
        "Sirius",
        "U2K2"
      ],
      "field_input": "Select Landscape",
      "field_message_ip_error_message": "Landscape is mandatory",
      "field_required": "1",
      "field_dropdown_option_component": [
          {
              "field_title": "",
              "field_options": []
          }
      ],
      "field_editable": "",
      "field_column_size": ""
  };

  //console.log(clusterData, "mcoDaata");
  //console.log(mcoData, "clusterData");
  clusterData.field_related_dropdown = "mco";

  mcoData.field_related_dropdown = "";

  // set cluster and mco data in table
  const [formData1, setFormData1] = useState([clusterData, mcoData]);

  // set lead paltform and area and subareaData
  const [formData2, setFormData2] = useState([
    leadPlatformData,
    areaData,
    subAreaData,
  ]);
// set Landscape approvers
  const [formData3, setFormData3] = useState([landscapData]);
  // get form values from form component
  const [getFormValues, setGetFormValues] = React.useState(false);
  // empty from values
  const [emptyFormValues, setEmptyFormValues] = React.useState(false);
  // state for form  values
  const [state, setState] = useState({});
  const [mobileAddUserForm, setMobileAddUserForm] = useState(false);
  const [mobileError, setmobileError] = useState(false);
 
  

  const [mobileSucess, setmobileSucess] = useState(false);

  // create user
  const submitCreateUser = async () => {
    //console.log("here  ---- on submit", createUserState);
    if (
      createUserState.userType == "firstGfcf" ||
      createUserState.userType == "gfcf" ||
      createUserState.userType == "firstLevelGPMApprover" ||
      createUserState.userType == "GPMapprover" ||
      createUserState.userType == "businessUserRegionWise"||
      createUserState.userType == "landscape"
    ) {
      setGetFormValues(true);
    } else {
      await addUser(createUserState);
    }
    if(checked){
      setChecked(false)
      setValued("")
    }
  };
  // create user
  const addUser = async (finalState) => {
  
    //console.log("finalState", finalState);
    //console.log("at the rate ---", createUserState.email.includes("@"));
    if (
      createUserState.email == "" ||
      !createUserState.email.includes("@") ||
      createUserState.email.split("@")[1] != "unilever.com"
    ) {
      //console.log("set flag true");
      if (isMobile) {
        //console.log("mobile  ---view");
        setmobileError(true);
        return;
      }
      setInvalidFlag(true);
      return;
    } 


    
    else {
      setmobileError(false);
      setInvalidFlag(false);
    }


    if (!finalState.userType) {
      setInvalidUserType(true)
      setUsertypeMobileError(true)
      return
    }
    else {
      setInvalidUserType(false)
      setUsertypeMobileError(false)
    }
    
    

    let bearerToken = "";
    if (
      typeof window != undefined &&
      localStorage.getItem("auth") != undefined &&
      localStorage.getItem("auth") != null
    ) {
      bearerToken = JSON.parse(localStorage.getItem("auth")).data.accessToken;
      //console.log("bearer Token ", bearerToken);
    }

    //console.log(createUserState, "state create user is here");

    //console.log("Final state ------", finalState);
    let dataToSend = finalState;
    //console.log("CHECKKKKKBEFORE", dataToSend);
    if ( dataToSend.userType == "gCad") {
      dataToSend.mco = "Global";
      dataToSend.cluster = "Global";
    }
    //console.log("CHECKKKKKlater", dataToSend)
    setLoaader(true);
    window.scrollTo(0, 0);
    
          let authCheck = JSON.parse(localStorage.getItem("auth")).data;
          let expiryStatus = await props.checkExpiry(authCheck);

    if (expiryStatus) {
      let auth = await JSON.parse(localStorage.getItem("auth")).data;
      axios({
        method: "post",
        url: `${endpoints.baseUrl}/user/createUser`,
        headers: {
          Authorization: auth.accessToken,
        },
        data: dataToSend,
      }).then((response) => {
        setLoaader(false);
        if (response.data.code == 200) {
          if (isMobile) {
            //setmobileSucess(true);
            setMobileAddUserForm(false);
          }
          //createUser[1].field_message[0]
          // else {
          setMessage(createUser[0].field_message[0]);
          setSuccessModal(true);
          setFail(false);
          //}
          setInvalidFlag(false);
          setmobileError(false);
          setCreateUserState(initialState);
        } else if (response.data.code == 403) {
          localStorage.removeItem("auth");
          sessionStorage.clear();
          setLoaader(false)
          props.sessionTimeOutCheck(true);
        } else if (response.data.code == 402) {
          setFail(true);
          setMessage(response.data.message);
          setSuccessModal(true);
          setInvalidFlag(false);
          setCreateUserState(initialState);
        } else if (response.data.code == 401) {
          setFail(true);
          setMessage(response.data.message);
          if (isMobile) {
            //setmobileSucess(true);
            setMobileAddUserForm(false);
          }
          // } else {
          setSuccessModal(true);
          //}
          setInvalidFlag(false);
          setCreateUserState(initialState);
        }
        //console.log("resposne create user api----", response);
        getUserData(null,"All", true);
        setFirstTime(true)
        setOffset(0)
        setPaginationNum(1);
        inputRef.current.value = ""
        setUserTypeFilter("All")
        setUserTypeToShow("All")
        setCreateUserState(initialState);
        setsearchUser("")
      });
    } else {
      setLoaader(false)
      props.sessionTimeOutCheck(true);
    }
  };

  // receive form data
  const recievedFormValues = async (formState) => {
    //console.log("Received form values ---------", formState);
    const finalState = { ...createUserState, ...formState };

    //console.log("final State ----", finalState);
    if(finalState.userType=="landscape"){
      if(finalState.landscape=='Global'){finalState.landscapeId='0';}
      if(finalState.landscape=='Fusion'){finalState.landscapeId='1';}
      if(finalState.landscape=='Sirius'){finalState.landscapeId='2';}
      if(finalState.landscape=='Cordillera'){finalState.landscapeId='3';}
      if(finalState.landscape=='U2K2'){finalState.landscapeId='4';}
    }
    await addUser(finalState);
    setGetFormValues(false);
  };

  // set state sa change of data

  const inputChange = (e) => {
    {/*console.log(
      e.target.name,
      "name of state to chanfge ",
      "e target value ---",
      e.target.value,
      e.target.checked,"e.target.checked"
    );*/}
    if(e.target.name=="userType"){
      setChecked(e.target.checked)
      setValued(e.target.value)
      
      
    }
    
    setCreateUserState({ ...createUserState, [e.target.name]: e.target.value });
    // React.useEffect(()=>{
    //     e.target.checked=false
    // },[checked])
    
  };

  const editThis = (email) => {
    //console.log(userData, "useralldataaaaa");

    setUserToBeEdited(
      filteredUserData.filter((item) => item.email == email)[0]
    );
    let modal = !editUser;
    setedituser(true);
    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  };

  const deleteThis = async (index) => {
    //console.log("delte this index", index);
    //console.log("user data ---", userData[index].email);
    let deleteEmail = userData[index].email;
    try {
      //console.log("auth ", authData);
      
          let authCheck = JSON.parse(localStorage.getItem("auth")).data;
          let expiryStatus = await props.checkExpiry(authCheck);

      if (expiryStatus) {
        let auth = await JSON.parse(localStorage.getItem("auth")).data;
        setAuthData(auth);
        setLoaader(true);
        const deleteUserResponse = await axios({
          method: "DELETE",
          url: `${endpoints.baseUrl}/user/deleteUser`,
          headers: {
            Authorization: auth.accessToken,
          },
          data: {
            email: deleteEmail,
          },
        });
        setLoaader(false);
        //console.log("Delete user  ---", deleteUserResponse);
        //console.log("delete failed ", deleteUser[1].field_message);
        if (deleteUserResponse.data.code == 200) {
          //deleteUser[0].field_message
          setMessage(`${deleteUser[0].field_message} ${deleteEmail}`);
          setSuccessModal(true);
          getUserData(null,"All", true);
          setFirstTime(true)
          setOffset(0)
          setPaginationNum(1);
          inputRef.current.value = ""
          setUserTypeFilter("All")
          setUserTypeToShow("All")
          setsearchUser("")
        } else if (deleteUserResponse.data.code == 401) {
          setMessage(`${deleteUser[1].field_message} ${deleteEmail}`);
          setSuccessModal(true);
          getUserData(searchUser, userTypeFilter);
          setLoaader(false);
        } else if (deleteUserResponse.data.code == 403) {
          props.sessionTimeOutCheck(true);
          setLoaader(false);
        }
      } else {
        props.sessionTimeOutCheck(true);
        setLoaader(false);
      }
    } catch (e) {
      console.log("error ---delete user", e);
      setLoaader(false);
    }
  };

  const [reload, setReload] = useState(false);
  
  React.useEffect(() => {
    if(reload) {   
      getUserData(searchUser)
      setReload(false)
      
   }
   
  }, [reload]);
 
  const handleDropDown = (item) => {
    setDropdownState(!dropDownState);
  }
  
  const closeAllDropdowns = () => {
    setDropdownState(false)
  }

  const userTypeArr = ["All", "Business Owner", "End user"]
  props.data.field_component[0].component.content.field_user_mapping_fields[1].field_input_values.map((item)=>[
    userTypeArr.push(item.field_input_value_1)
  ])
//console.log(userTypeArr,"userTypeArr");

const gotDropDownValue = (value,dropdownParent,haveRelated)=>{
   
    
    
    let dropdownValueArr = props.data.field_component[0].component.content.field_user_mapping_fields[1].field_input_values.filter(item => item.field_input_value_1 == value)

      //console.log(dropdownValueArr,"dropdownValueArr");
   let filterParam = ""
      if(value=="All"){
        filterParam = "All"
        setUserTypeFilter("All")
      }
      else if ( value == "Business Owner"){
        filterParam = "businessOwner"
        setUserTypeFilter("businessOwner")
      }
      
      else if (value == "End user"){
        filterParam = "endUser"
        setUserTypeFilter("endUser")
      }
       
      else{
        setUserTypeFilter(dropdownValueArr[0].field_input_value_2)
        filterParam = dropdownValueArr[0].field_input_value_2
      }

      getUserData(null,filterParam, true)
      setOffset(0)
      setPaginationNum(1);
      inputRef.current.value = ""
      setDropdownState(false)
      setUserTypeToShow(value)
      

  }


const userEdited = () => {
  //console.log("Icamehere")
  getUserData(null,"All", true);
  setFirstTime(true)
  setOffset(0)
  setPaginationNum(1);
  inputRef.current.value = ""
  setUserTypeFilter("All")
  setUserTypeToShow("All")
  setsearchUser("")
}


  
  const callApi = () => { setReload(true) };
  const [debounceCall] = React.useState(() => _.debounce(callApi, 1000))

  const searchInTable = async (e) => {
    //console.log("search addmin acess zone ---", e.target.value);

 
    if (e.target.value.length >= 3) {
      setUserTypeFilter("All")
      setUserTypeToShow("All")
     
      setOffset(0);
      let search = e.target.value.split(" ");
      
      //console.log("search ", search[0]);
      setsearchUser(search[0]);
      debounceCall()
     // getUserData(search[0]);
      setPaginationNum(1);
    }
    else {
      
        setsearchUser("");
        debounceCall()
      
    }

    // if (e.target.value.length == 0) {
    //   setFilteredUserData(userData);
    // } else {
    //   const options = {
    //     shouldSort: true,
    //     keys: ["userType", "email"],
    //   };

    //   const fuse = new Fuse(userData, options);
    //   // Change the pattern
    //   const pattern = e.target.value;
    //   console.log("pattern  -----", pattern);
    //   let fuseResult = fuse.search(`${pattern}`);

    //   let filteredResult = [];
    //   console.log("fusee result  ----", fuseResult);
    //   for (let i in fuseResult) {
    //     filteredResult.push(fuseResult[i].item);
    //   }
    //   setFilteredUserData(filteredResult);
    // }
  };
  return (
    <div className="container mt-4">
      <div className={styles.containerUser}>
        <div className={styles.left}>
          <p>
            {_get(
              props,
              "data.field_component[0].component.content.field_title",
              ""
            )}
          </p>

          <div className={styles.userModal}>
            <div className={styles.formGroup}>
              <label>
                {_.get(
                  props,
                  "data.field_component[0].component.content.field_user_mapping_fields[0].field_label",
                  ""
                )}
                <sup>*</sup>
              </label>
              <input
                className={`${invalidFlag ? styles.errorBorder : null}`}
                type="text"
                placeholder={_.get(
                  props,
                  "data.field_component[0].component.content.field_user_mapping_fields[0].field_title",
                  ""
                )}
                name="email"
                onChange={inputChange}
                value={createUserState.email}
              />
              {invalidFlag ? (
                <span className={styles.errorMessage}>
                  {_.get(
                    props,
                    "data.field_component[0].component.content.field_user_mapping_fields[0].field_message_ip_error_message",
                    ""
                  )}
                </span>
              ) : null}
            </div>

            <div className={styles.formGroup}>
              <label className={styles.mainLabel}>
                {_.get(
                  props,
                  "data.field_component[0].component.content.field_user_mapping_fields[1].field_label",
                  ""
                )}
              </label>
              <div className={styles.inputGroupWrapper} onChange={inputChange}>
                {_get(
                  props,
                  "data.field_component[0].component.content.field_user_mapping_fields[1].field_input_values",
                  []
                ).map((item, index) => (
                  <label className={styles.radioWrapper} key={index}>
                    <span className={styles.subLabel}>
                      {_get(item, "field_input_value_1", "")}
                    </span>
                    <input
                      type="radio"
                      className={styles.radioBox}
                      value={_get(item, "field_input_value_2", "")}
                      name="userType"
                      checked = {_get(item, "field_input_value_2", "")==valued?true:false} 
                    />
                    <span className={styles.radioCheckmark}></span>
                    
                  </label>
                ))}
              </div>
            </div>
		 { createUserState.userType == "businessUserRegionWise" ? (
              <BasicForm
                data={formData1}
                sendFormValues={recievedFormValues}
                getFormValues={getFormValues}
                emptyFormValues={emptyFormValues}
                formType="userCreateData"
                // editState={state}
                demandEditData={props.userToBeEdited}
                setGetFormValues={setGetFormValues}
                type="user"
                params="userAccess"
              />
		) : null}
             { createUserState.userType == "firstGfcf" ||
            createUserState.userType == "gfcf" ? (
              <>
              <BasicForm2
                  data={[...formData1,...formData2] }
                  sendFormValues={recievedFormValues}
                  getFormValues={getFormValues}
                  emptyFormValues={emptyFormValues}
                  notRequired={['Area','Sub Area','MCO','Lead Platform']}
                  formType="userCreateData"
                  // editState={state}
                  demandEditData={props.userToBeEdited}
                  type="user"
                  setGetFormValues={setGetFormValues}
                  params="userAccess"
                />
              </>
            ) : null}
             {createUserState.userType == "landscape" ? (
              <BasicForm3
                data={formData3}
		notRequired={[]}
                sendFormValues={recievedFormValues}
                getFormValues={getFormValues}
                emptyFormValues={emptyFormValues}
                formType="userCreateData"
                demandEditData={props.userToBeEdited}
		notRequired={['']}
                type="user"
                setGetFormValues={setGetFormValues}
                params="userAccess"
              />
            ) : null}
            {createUserState.userType == "firstLevelGPMApprover" ||
            createUserState.userType == "GPMapprover" ? (
              <BasicForm2
                data={formData2}
                sendFormValues={recievedFormValues}
                getFormValues={getFormValues}
                emptyFormValues={emptyFormValues}
                formType="userCreateData"
                notRequired={['Area','Sub Area','MCO']}
                // editState={state}
                demandEditData={props.userToBeEdited}
                type="user"
                setGetFormValues={setGetFormValues}
                params="userAccess"
              />
            ) : null}

            { 
              <div  className={styles.userTypeerrorMessage}>
              { invalidUserType ? <span className={styles.errorMessage}>
              Please select usertype
            </span> : null }
            </div>
            }

           

            <div className={styles.formGroup} onClick={submitCreateUser}>
              <span className={styles.btn}>
                {_get(
                  props,
                  "data.field_component[0].component.content.field_label",
                  ""
                )}
              </span>
            </div>
            {/* <div className={styles.formGroup} onClick={CreateNewUser}>
              <span className={styles.btn}>Upload Files</span>
            </div> */}
          </div>
        </div>

        <div className={styles.right}>
          <div className={styles.head}>
            <p>
              {_get(
                props,
                "data.field_component[0].component.content.field_input",
                ""
              )}
            </p>
           
             

            <div className={styles.dropdownsearch}>
              <div className={styles.listWrapper}>
                <div className={styles.inputGroup}>
                 
                 <p
                    className={`${styles.input}`}
                    onClick={() => {
                      handleDropDown(props.data.field_component[0].component.content.field_user_mapping_fields[1].field_label);
                    }}
                  >
                    <span className={styles.left}>
                      {usertypeToShow 
                        ?  usertypeToShow
                        : "Select User Type"}
                       
                    </span>
                    <span className={styles.right}>
                      <Icons name="chevron" className={styles.chevron} />
                    </span>
                  </p>
                </div>
                  {
                   dropDownState == true ?
                    <DropDown
                    dropdownParent={props.data.field_component[0].component.content.field_user_mapping_fields[1].field_label}
                    closeAllDropdowns={closeAllDropdowns}
                    //params = ""
                    values={userTypeArr}
                      
                    getDropdownValue={gotDropDownValue}
                    
                    />
                    : null
                  }
            </div>
              
              
           
            
            <div
              className={styles.mobileBtn}
              onClick={() => setMobileAddUserForm(true)}
            >
              <span className={styles.mobile}>
                {_get(
                  props,
                  "data.field_component[0].component.content.field_title",
                  ""
                )}
              </span>
            </div>
            <div className={styles.search}>
              <Icons name="searchGrayIcon" className={styles.searchIcon} />
              <input
                type="text"
                placeholder="Search"
                onChange={searchInTable}
                ref={inputRef}
               // value = {searchUser}
              />
            </div>
          </div>
        </div>
          <div className={styles.scrollableTable}>
          {loader ? <Loader /> : 
          filteredUserData.length !=0 ?
            <table>
              <thead>
                <tr>
                  <th>SN</th>
                  <th>E mail Id</th>
                  <th>Work level</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                
                {filteredUserData.map((user, index) => (
                  <tr>
                    <td>{offset + index + 1}</td>
                    <td>{user.email}</td>
                    <td>
                      {user.userType == "admin"
                        ? "Admin"
                        : user.userType == "gCad"
                        ? "GCAD"
                        : user.userType == "supportStatus"
                        ? "Support"
                        : user.userType == "releaseManager"
                        ? "Release Manager"
                        : user.userType == "firstLevelGPMApprover"
                        ? "First level GPM"
                        : user.userType == "endUser"
                        ? "End user"
                        : user.userType == "GPMapprover"
                        ? "Second level GPM"
                        : user.userType == "firstGfcf"
                        ? "First level GFCF"
                        : user.userType == "gfcf"
                        ? "Second level GFCF"
                        : user.userType == "internalUser"
                        ? "Internal user"
                        : user.userType == "businessUserRegionWise"
                        ? "Business user(region-wise)"
                        : user.userType == "qrManager"
                        ? "QR Manager"
                        : user.userType == "businessOwner"	
                        ? "Business Owner"
                        :  user.userType}
                    </td>
                    <td>
                      {" "}
                      <Icons
                        name="pencilDark"
                        className={styles.editInactive}
                        onClick={() => {
                          editThis(user.email);
                        }}
                      />
                      <Icons
                        name="deleteicon"
                        className={styles.icon}
                        onClick={() => {
                          deleteThis(index);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
              {/* {loader ? <Loader /> : null} */}
            </table> : 
            <div className={`${styles.noresults} container`}>
            <img
              src={`${endpoints.drupalIp}${_.get(
               props.data,
                "field_component[5].component.content.field_no_result_image[0].file_url",
                ""
              )}`}
            />
            <h3 className={styles.head}>
              {" "}
              {_.get(props.data,"field_component[5].component.content.field_title", "")}
            </h3>
            <div
              className={styles.content}
              dangerouslySetInnerHTML={{
                __html: _.get(props.data,"field_component[5].component.content.field_details", ""),
              }}
            ></div>
          </div>
             }
          </div>

          { filteredUserData.length != 0 ? (
            <Pagination
              totalLength={userCount}
              paginationNum={paginationNum}
              setPaginationNum={setPaginationNum}
            />
          ) : null}
        </div>

        {successModal ? (
          <SuccessModal
            setSuccessModal={setSuccessModal}
            title={"User Access Mapping"}
            message={message}
            setMessage={setMessage}
            fail={fail}
            setFail={setFail}
          />
        ) : null}

        {!isMobile && editUser ? (
          <Edituser
            userToBeEdited={userToBeEdited}
            globalData={props.globalData}
            editFormDrupalData={_get(props, "data.field_component[1]", [])}
            setedituser={setedituser}
            getUserData={getUserData}
            setSuccessModal={setSuccessModal}
            setMessage={setMessage}
            setFail={setFail}
            editUserSucessFailure={editUserSucessFailure}
            inputRef={inputRef}
            userEdited = {userEdited}
          />
        ) : isMobile && editUser ? (
          <AddUser
            editUser={true}
            mobileAddUser={props}
            inputChange={inputChange}
            setEditUser={setedituser}
            formData1={formData1}
            formData2={formData2}
            formData3={formData3}
            mobileSucess={mobileSucess}
            setmobileSucess={setmobileSucess}
            userToBeEdited={userToBeEdited}
            getUserData={getUserData}
            userEdited = {userEdited}
          />
        ) : null}
        {mobileAddUserForm ? (
          <AddUser
            editUser={false}
            mobileAddUser={props}
            inputChange={inputChange}
            createUserState={createUserState}
            setMobileAddUserForm={setMobileAddUserForm}
            addUser={addUser}
            formData1={formData1}
            formData2={formData2}
 	          formData3={formData3}
            mobileError={mobileError}
            setmobileError={setmobileError}
            invalidUsertypeMobileError = {invalidUsertypeMobileError}
            setUsertypeMobileError = {setUsertypeMobileError}
            mobileSucess={mobileSucess}
            setmobileSucess={setmobileSucess}
            userEdited = {userEdited}
          />
        ) : null}
        {/* <Pagination /> */}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);


